module.exports = __webpack_public_path__ + "img/0x47bead2563dcbf3bf2c9407fea4dc236faba485a.d75234a8.png";